import { FC, SVGProps } from 'react'
import theme from 'theme'

type Props = SVGProps<SVGSVGElement> & {
  sx?: Record<string, unknown>
}

const AddIcon: FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.875 3.875C10.875 3.39175 10.4832 3 10 3C9.51675 3 9.125 3.39175 9.125 3.875V9.125H3.875C3.39175 9.125 3 9.51675 3 10C3 10.4832 3.39175 10.875 3.875 10.875L9.125 10.875V16.125C9.125 16.6082 9.51675 17 10 17C10.4832 17 10.875 16.6082 10.875 16.125V10.875L16.125 10.875C16.6082 10.875 17 10.4832 17 10C17 9.51675 16.6082 9.125 16.125 9.125H10.875V3.875Z"
      fill={theme.colors.textPrimary}
    />
  </svg>
)

export default AddIcon
